import React, { useEffect, useRef } from "react";
import s from './MyComponentLoading.module.css';

export default function MyComponentLoading() {
	
	return (<div className={s.loadingHolder}>
		<div className={s.loading}>Loading</div>
	</div>)
}

